document.addEventListener("click", event => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest("[data-content-image-open]");
  if (trigger instanceof HTMLElement) {
    const documentView = trigger.closest(".content-document");
    const dialog = documentView?.querySelector("[data-content-image-dialog]");
    if (!(dialog instanceof HTMLDialogElement)) return;

    const image = dialog.querySelector("[data-content-image-dialog-image]");
    const caption = dialog.querySelector("[data-content-image-dialog-caption]");
    const fullLink = dialog.querySelector("[data-content-image-dialog-full]");
    const full = trigger.dataset.contentImageFull;
    if (
      !(image instanceof HTMLImageElement) ||
      !(caption instanceof HTMLElement) ||
      !(fullLink instanceof HTMLAnchorElement) ||
      !full
    )
      return;

    image.src = full;
    image.alt = trigger.dataset.contentImageAlt ?? "";
    caption.textContent = trigger.dataset.contentImageCaption ?? "";
    caption.hidden = !caption.textContent;
    fullLink.href = full;
    dialog.showModal();
    return;
  }

  const dialog = target.closest("[data-content-image-dialog]");
  if (dialog instanceof HTMLDialogElement && target === dialog) dialog.close();
});
